<template>
  <svg
    id="Layer_4"
    data-name="Layer 4"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 600 242.94"
  >
    <defs>
      <linearGradient
        id="linear-gradient4-1"
        x1="139.9"
        y1="181.31"
        x2="182.87"
        y2="166.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset=".4"
          stop-color="#973386"
        />
        <stop
          offset=".42"
          stop-color="#9f377b"
        />
        <stop
          offset=".57"
          stop-color="#c84f46"
        />
        <stop
          offset=".71"
          stop-color="#e56120"
        />
        <stop
          offset=".81"
          stop-color="#f86c08"
        />
        <stop
          offset=".87"
          stop-color="#ff7000"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient4-2"
        x1="101.64"
        y1="139.97"
        x2="138.53"
        y2="194.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset=".54"
          stop-color="#973386"
        />
        <stop
          offset=".56"
          stop-color="#9f377b"
        />
        <stop
          offset=".71"
          stop-color="#c84f46"
        />
        <stop
          offset=".84"
          stop-color="#e56120"
        />
        <stop
          offset=".94"
          stop-color="#f86c08"
        />
        <stop
          offset="1"
          stop-color="#ff7000"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient4-3"
        x1="242.09"
        y1="181.31"
        x2="285.06"
        y2="166.18"
        xlink:href="#linear-gradient4-1"
      />
      <linearGradient
        id="linear-gradient4-4"
        x1="203.84"
        y1="139.97"
        x2="240.72"
        y2="194.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset=".54"
          stop-color="#973386"
        />
        <stop
          offset=".56"
          stop-color="#9f377b"
        />
        <stop
          offset=".71"
          stop-color="#c84f46"
        />
        <stop
          offset=".84"
          stop-color="#e56120"
        />
        <stop
          offset=".94"
          stop-color="#f86c08"
        />
        <stop
          offset="1"
          stop-color="#ff7000"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient4-5"
        x1="344.34"
        y1="181.31"
        x2="387.31"
        y2="166.18"
        xlink:href="#linear-gradient4-1"
      />
      <linearGradient
        id="linear-gradient4-6"
        x1="306.08"
        y1="139.97"
        x2="342.97"
        y2="194.69"
        xlink:href="#linear-gradient4-4"
      />
      <linearGradient
        id="linear-gradient4-7"
        x1="446.49"
        y1="181.31"
        x2="489.46"
        y2="166.18"
        xlink:href="#linear-gradient4-1"
      />
      <linearGradient
        id="linear-gradient4-8"
        x1="408.23"
        y1="139.97"
        x2="445.12"
        y2="194.69"
        xlink:href="#linear-gradient4-4"
      />
    </defs>
    <rect
      width="600"
      height="242.94"
      fill="#fff"
      stroke-width="0"
    />
    <g>
      <path
        d="M150.62,98.28v-5.71h-.19c-2.95,4.86-8.29,7.43-15.81,7.43-16,0-26.47-12.28-26.47-28.28s10.76-28.09,26.19-28.09c6.1,0,11.05,1.81,15.52,6.29v-22.09h15.81v70.47h-15.05ZM150.72,71.62c0-7.33-5.62-13.24-13.43-13.24s-13.33,5.52-13.33,13.24,5.62,13.62,13.24,13.62,13.52-5.81,13.52-13.62Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M188.38,76.66c.86,6,5.9,10,12.38,10,4.28,0,7.05-1.62,9.62-4.95h16.19c-5.05,11.52-14.67,18.28-25.81,18.28-15.24,0-28-12.28-28-28s12.19-28.38,27.71-28.38,27.9,12.48,27.9,28.85c0,1.52-.1,2.76-.38,4.19h-39.62ZM212.57,66c-1.24-5.43-6-9.05-12.09-9.05-5.71,0-10.66,3.43-11.9,9.05h24Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M237.71,98.28v-40.85h-5.9v-12h5.9v-2.19c0-8.76,3.43-16.76,20.28-16.76h6.65v11.9h-5.03c-4.1,0-6.1,1.05-6.1,5.43v1.62h11.13v12h-11.13v40.85h-15.81Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M310.18,98.28v-5.71h-.19c-2.29,4.67-8.57,7.52-15.52,7.52-15.62,0-26.48-12.28-26.48-28.28s11.33-28.19,26.48-28.19c6.48,0,12.47,2.57,15.52,7.43h.19v-5.62h15.81v52.85h-15.81ZM310.18,71.81c0-7.43-6-13.43-13.43-13.43s-12.95,6-12.95,13.62,5.81,13.33,13.14,13.33,13.24-5.9,13.24-13.52Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M376.74,115.84v-22.99h-.19c-3.43,4.67-8.86,7.14-16,7.14-14.76,0-25.52-12-25.52-27.14,0-16.76,10.86-29.24,26.48-29.24,6.76,0,12.66,2.57,15.71,7.62h.19v-5.81h15.14v70.42h-15.81ZM377.31,71.9c0-7.52-5.9-13.52-13.43-13.52s-13.05,5.71-13.05,13.81c0,7.14,5.9,13.05,13.24,13.05s13.24-6,13.24-13.33Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M407.12,98.28v-40.85h-7.81v-12h7.81v-17.62h15.81v17.62h11.1v12h-11.1v40.85h-15.81Z"
        fill="#392388"
        stroke-width="0"
      />
      <path
        d="M465.49,99.9c-16.09,0-28.47-11.9-28.47-28.09s12.67-28.09,28.47-28.09,28.47,11.9,28.47,27.9-12.57,28.28-28.47,28.28ZM478.15,71.81c0-7.05-5.33-13.33-12.76-13.33-6.95,0-12.57,6.09-12.57,13.33s5.52,13.33,12.67,13.33,12.67-6.29,12.67-13.33Z"
        fill="#392388"
        stroke-width="0"
      />
    </g>
    <g>
      <g>
        <polygon
          points="189.38 164.69 163 183.84 156.77 164.7 189.38 164.69"
          fill="url(#linear-gradient4-1)"
          stroke-width="0"
        />
        <polygon
          points="104.04 164.69 163 183.84 146.71 133.69 136.64 164.7 104.04 164.69"
          fill="#ff7000"
          stroke-width="0"
        />
        <polygon
          points="104.04 164.69 163 183.84 173.08 214.85 146.71 195.68 120.34 214.85 130.42 183.84 104.04 164.69"
          fill="url(#linear-gradient4-2)"
          stroke-width="0"
        />
      </g>
      <g>
        <polygon
          points="291.57 164.69 265.19 183.84 258.96 164.7 291.57 164.69"
          fill="url(#linear-gradient4-3)"
          stroke-width="0"
        />
        <polygon
          points="206.23 164.69 265.19 183.84 248.91 133.69 238.84 164.7 206.23 164.69"
          fill="#ff7000"
          stroke-width="0"
        />
        <polygon
          points="206.23 164.69 265.19 183.84 275.27 214.85 248.91 195.68 222.53 214.85 232.62 183.84 206.23 164.69"
          fill="url(#linear-gradient4-4)"
          stroke-width="0"
        />
      </g>
      <g>
        <polygon
          points="393.82 164.69 367.44 183.84 361.21 164.7 393.82 164.69"
          fill="url(#linear-gradient4-5)"
          stroke-width="0"
        />
        <polygon
          points="308.48 164.69 367.44 183.84 351.15 133.69 341.09 164.7 308.48 164.69"
          fill="#ff7000"
          stroke-width="0"
        />
        <polygon
          points="308.48 164.69 367.44 183.84 377.52 214.85 351.15 195.68 324.78 214.85 334.87 183.84 308.48 164.69"
          fill="url(#linear-gradient4-6)"
          stroke-width="0"
        />
      </g>
      <g>
        <polygon
          points="495.96 164.69 469.58 183.84 463.36 164.7 495.96 164.69"
          fill="url(#linear-gradient4-7)"
          stroke-width="0"
        />
        <polygon
          points="410.62 164.69 469.58 183.84 453.3 133.69 443.23 164.7 410.62 164.69"
          fill="#ff7000"
          stroke-width="0"
        />
        <polygon
          points="410.62 164.69 469.58 183.84 479.66 214.85 453.3 195.68 426.92 214.85 437.01 183.84 410.62 164.69"
          fill="url(#linear-gradient4-8)"
          stroke-width="0"
        />
      </g>
    </g>
    <path
      d="M594.1,5.9v231.14H5.9V5.9h588.2M600,0H0v242.94h600V0h0Z"
      fill="#392388"
      stroke-width="0"
    />
  </svg>
</template>

<script>
export default {
  name: 'defaqto-rating4',
};
</script>
